import {PageAsForm} from "../themes/hya-prime-block/components/layouts/PageAsForm";

export const Home = () => {
    return (
      <PageAsForm schema={{}} onSubmit={()=>{}} title={"Home Page"} subtitle={"lorem Ipsum"}  >
        <h3>Questa è la home</h3>
      </PageAsForm>
  );
};